import React from "react";
import { useParams } from "react-router-dom";
import { useApplication } from "../../context/ApplicationContext";
import { resolveAssetUrl } from "../../utils/assets";
import { socialsFromApplication, SocialIcon, socialLabel } from "../SocialIcons/SocialIcons";
import { normalizeExternalUrl } from "../../utils/urls";
import './footer.css'

const PLATFORM_CONTACT = "info@ceformedsrl.it";
const CEFORMED_SITE = "https://ceformedsrl.it";

const Footer = () => {
    const { application } = useApplication();
    const { appSlug } = useParams();
    const slug = appSlug || application?.slug;
    const isMainSite = !slug;
    const logoSrc = resolveAssetUrl(application?.logo_url);
    const supportEmail = isMainSite
        ? PLATFORM_CONTACT
        : (application?.support_email || PLATFORM_CONTACT);
    const supportPhone = application?.support_phone;
    const footerLinks = application?.footer_links || [];
    const socialLinks = socialsFromApplication(application);

    return (
        <footer className={`footer${isMainSite ? " footer--platform" : ""}`} style={{ backgroundColor: application?.secondary_color || "#202a2e" }}>
            <div className="footer-content">
                <div className={`footer-columns${isMainSite ? " footer-columns--platform" : ""}`}>
                    <div className="footer-column footer-column-brand">
                        <div className="logo-details">
                            <img
                                src={logoSrc}
                                alt={application?.name || "Logo"}
                                className={`footerLogo${isMainSite ? " footerLogo--platform" : ""}`}
                            />
                            {!isMainSite && (
                            <div className="footerBrandText">
                                <span className="logo_name">{application?.site_title || application?.name}</span>
                                <span className="logo_subtitle">{application?.site_subtitle || ""}</span>
                            </div>
                            )}
                        </div>
                        {!isMainSite && socialLinks.length > 0 && (
                        <div className="footer-social-icons">
                            {socialLinks.map((social) => (
                            <a
                                key={`${social.network}-${social.url}`}
                                href={normalizeExternalUrl(social.url)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`footer-social-icon footer-social-icon--${social.network}`}
                                aria-label={socialLabel(social.network)}
                            >
                                <SocialIcon network={social.network} />
                            </a>
                            ))}
                        </div>
                        )}
                    </div>
                    {!isMainSite && footerLinks.length > 0 && (
                    <ul className="box footer-column">
                        <li className="link_name">LINK UTILI</li>
                        {footerLinks.map((link) => (
                            <li key={`${link.label}-${link.url}`}>
                                <a href={normalizeExternalUrl(link.url)} target="_blank" rel="noopener noreferrer">{link.label}</a>
                            </li>
                        ))}
                    </ul>
                    )}
                    <ul className="box footer-column">
                        <li className="link_name">CONTATTI</li>
                        <li>
                            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
                        </li>
                        {!isMainSite && supportPhone && <li>{supportPhone}</li>}
                    </ul>
                </div>
            </div>
            <div className="bottom-details">
                <div className="bottom_text">
                    <span className="copyright_text">
                        Copyright © 2026 WebinarPlus
                        <span className="copyright_sep" aria-hidden="true"> · </span>
                        Sviluppato da{" "}
                        <a href={CEFORMED_SITE} target="_blank" rel="noopener noreferrer">Ceformed srl</a>
                        <span className="copyright_sep" aria-hidden="true"> · </span>
                        Tutti i diritti riservati
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
